<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.813103 0.320931C0.764888 0.0998462 0.543806 -0.0353916 0.322723 0.00811966C0.100465 0.0575108 -0.0394757 0.277419 0.00991507 0.49968L4.26105 19.6787C4.30338 19.8704 4.4739 19.9998 4.66205 19.9998C4.69145 19.9998 4.72203 19.9974 4.75143 19.9904C4.97368 19.941 5.11363 19.7211 5.06423 19.4988L0.813103 0.320931Z"
      :fill="iconColor"
    />
    <path
      d="M19.6886 9.09717L17.5684 6.97688C17.1532 6.56176 16.4782 6.56528 16.0655 6.97688L7.62788 15.4157C7.53027 15.5133 7.30214 15.7415 6.67299 19.5199C6.65065 19.6504 6.69416 19.7857 6.78824 19.8786C6.86585 19.9562 6.97051 19.9997 7.07988 19.9997C7.10222 19.9997 7.12456 19.9985 7.14691 19.995C10.9218 19.367 11.1546 19.1377 11.2522 19.0401L19.691 10.6024C20.1026 10.1873 20.1037 9.51347 19.6886 9.09717ZM19.1077 10.0191L10.7019 18.425C10.4102 18.5532 8.99318 18.8402 7.58202 19.086C7.83485 17.6336 8.12649 16.1825 8.20998 15.9978L16.6464 7.56016C16.6934 7.51312 16.7558 7.4896 16.8181 7.4896C16.8792 7.4896 16.9404 7.51312 16.9886 7.56016L19.1077 9.67928C19.2006 9.77336 19.2006 9.92624 19.1077 10.0191Z"
      :fill="iconColor"
    />
    <path
      d="M16.6275 9.46063L9.47175 16.6153C9.31064 16.7752 9.31064 17.0351 9.47175 17.1962C9.55171 17.2762 9.65755 17.3174 9.76339 17.3174C9.86922 17.3174 9.97389 17.2774 10.055 17.1962L17.2096 10.0427C17.3707 9.88163 17.3707 9.62174 17.2096 9.46063C17.0485 9.29952 16.7875 9.29952 16.6275 9.46063Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconDraw",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
